import { type FC, type MouseEvent } from "react";

import { Checkbox } from "mds/components/Checkbox";
import { ListItem } from "mds/components/ListItem";
import { FolderIcon } from "mds/icons";
import { CourseWithGroupingType } from "store/selectors/types";

type CourseSelectionListProps = {
  courses: CourseWithGroupingType[];
  selectedCourseIds: string[];
  onCourseToggle: (courseId: string) => void;
};

export const CourseSelectionList: FC<CourseSelectionListProps> = ({
  courses,
  selectedCourseIds,
  onCourseToggle,
}) => {
  const handleCourseSelected = (event: MouseEvent, courseId: string) => {
    event.preventDefault();
    event.stopPropagation();
    onCourseToggle(courseId);
  };

  if (courses.length === 0) {
    return null;
  }

  return (
    <div className="max-h-[150px] overflow-y-scroll rounded-lg border border-black-tint-90 p-2">
      {courses.map((course) => (
        <div key={course.id}>
          <ListItem className="w-full gap-2">
            <Checkbox
              checked={selectedCourseIds.includes(course.id)}
              className="w-full"
              onContainerClick={(e) => handleCourseSelected(e, course.id)}
            >
              <span className="flex w-full items-center justify-between">
                <span>{course.code}</span>

                {course.groupingTitle && (
                  <span className="flex items-center gap-1">
                    <FolderIcon className="size-4 text-black-tint-70" />
                    <span className="text-black-tint-70">{course.groupingTitle}</span>
                  </span>
                )}
              </span>
            </Checkbox>
          </ListItem>
        </div>
      ))}
    </div>
  );
};
